(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rr-guide-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.__rrgdfLoaded) return;
  window.__rrgdfLoaded = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* Un seul dépliant ouvert à la fois (l’attribut name le fait déjà ; ceci couvre les anciens navigateurs). */
  function wireDetails(root) {
    var items = root.querySelectorAll('details.rrgdf-item');
    Array.prototype.forEach.call(items, function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        Array.prototype.forEach.call(items, function (o) {
          if (o !== d && o.open) o.open = false;
        });
      });
    });
  }

  /* Apparition au défilement : masquage posé par le JS seulement. */
  function wireReveal(root) {
    if (mq.matches || !('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var items = root.querySelectorAll('[data-rrgdf-rv]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('rrgdf-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    var vh = window.innerHeight || 800;
    Array.prototype.forEach.call(items, function (el) {
      if (el.getBoundingClientRect().top < vh * 0.94) return;
      var sibs = el.parentNode ? el.parentNode.children : [];
      var idx = Array.prototype.indexOf.call(sibs, el);
      el.style.setProperty('--rrgdf-d', Math.min(Math.max(idx, 0), 4) * 0.09 + 's');
      el.classList.add('rrgdf-pre');
      io.observe(el);
    });
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-rrgdf]');
    Array.prototype.forEach.call(roots, function (r) {
      if (r.__rrgdfReady) return;
      r.__rrgdfReady = true;
      wireDetails(r);
      wireReveal(r);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.__rrgdLoaded) return;
  window.__rrgdLoaded = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function headerHeight() {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rr-hh'));
    return isNaN(v) ? 66 : v;
  }

  /* Apparition au défilement : le masquage n’est posé qu’ici, donc sans JS tout reste visible. */
  function initReveal(root) {
    if (mq.matches || !('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var items = root.querySelectorAll('[data-rrgd-rv]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('rrgd-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    var vh = window.innerHeight || 800;
    Array.prototype.forEach.call(items, function (el) {
      if (el.getBoundingClientRect().top < vh * 0.94) return;
      var sibs = el.parentNode ? el.parentNode.children : [];
      var idx = Array.prototype.indexOf.call(sibs, el);
      el.style.setProperty('--rrgd-d', Math.min(Math.max(idx, 0), 4) * 0.09 + 's');
      el.classList.add('rrgd-pre');
      io.observe(el);
    });
  }

  /* Sommaire flottant : défilement doux au clic, puce active qui suit la lecture. */
  function initDock(root) {
    var list = root.querySelector('.rrgd-dock__list');
    if (!list) return;
    var links = Array.prototype.slice.call(list.querySelectorAll('.rrgd-dock__link'));
    var targets = [];

    /* Indique par des classes si la liste défile (is-scrollable) et de quel côté il reste des pastilles. */
    var fadeQueued = false;
    function updateFade() {
      fadeQueued = false;
      var max = list.scrollWidth - list.clientWidth;
      var scrollable = max > 2;
      list.classList.toggle('is-scrollable', scrollable);
      list.classList.toggle('is-scrolled', scrollable && list.scrollLeft > 2);
      list.classList.toggle('is-end', scrollable && list.scrollLeft >= max - 2);
    }
    function queueFade() {
      if (fadeQueued) return;
      fadeQueued = true;
      if (window.requestAnimationFrame) { window.requestAnimationFrame(updateFade); } else { updateFade(); }
    }
    list.addEventListener('scroll', queueFade, { passive: true });
    window.addEventListener('resize', queueFade);
    window.addEventListener('load', queueFade);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(queueFade); }
    updateFade();

    /* Au clavier : une pastille qui prend le focus reste entièrement visible, hors de la zone de fondu. */
    list.addEventListener('focusin', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!a || !list.contains(a) || list.scrollWidth <= list.clientWidth + 2) return;
      var pad = 28;
      var cur = list.scrollLeft;
      var next = cur;
      if (cur > a.offsetLeft - pad) { next = a.offsetLeft - pad; }
      else if (cur < a.offsetLeft + a.offsetWidth + pad - list.clientWidth) { next = a.offsetLeft + a.offsetWidth + pad - list.clientWidth; }
      next = Math.max(0, Math.min(next, list.scrollWidth - list.clientWidth));
      if (Math.abs(next - cur) > 1) {
        if (list.scrollTo) { list.scrollTo({ left: next, behavior: mq.matches ? 'auto' : 'smooth' }); } else { list.scrollLeft = next; }
      }
    });

    function setActive(a) {
      links.forEach(function (l) {
        if (l === a) { l.setAttribute('aria-current', 'location'); } else { l.removeAttribute('aria-current'); }
      });
      if (a && list.scrollWidth > list.clientWidth + 2) {
        var left = a.offsetLeft - (list.clientWidth - a.offsetWidth) / 2;
        if (list.scrollTo) { list.scrollTo({ left: left, behavior: mq.matches ? 'auto' : 'smooth' }); } else { list.scrollLeft = left; }
      } else if (!a && list.scrollLeft > 0 && !list.contains(document.activeElement)) {
        /* Plus aucune partie active (on remonte tout en haut) : la liste revient à sa première pastille. */
        if (list.scrollTo) { list.scrollTo({ left: 0, behavior: mq.matches ? 'auto' : 'smooth' }); } else { list.scrollLeft = 0; }
      }
      queueFade();
    }

    links.forEach(function (a) {
      var id = (a.getAttribute('href') || '').slice(1);
      var t = id ? document.getElementById(id) : null;
      if (t) targets.push({ el: t, link: a });
      a.addEventListener('click', function (ev) {
        if (!t) return;
        ev.preventDefault();
        t.scrollIntoView({ behavior: mq.matches ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', '#' + id); } catch (err) { /* sans effet */ }
        setActive(a);
        /* Le focus suit la lecture : le Tab suivant part de la partie atteinte, pas de la pastille suivante. */
        if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
        try { t.focus({ preventScroll: true }); } catch (err2) { /* sans effet */ }
      });
    });

    if (!('IntersectionObserver' in window) || !targets.length) return;
    var seen = {};
    var topOffset = Math.round(headerHeight() + 12 + 72 + 8);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { seen[e.target.id] = e.isIntersecting; });
      var current = null;
      targets.forEach(function (t) { if (seen[t.el.id]) current = t; });
      setActive(current ? current.link : null);
    }, { rootMargin: '-' + topOffset + 'px 0px -55% 0px' });
    targets.forEach(function (t) { io.observe(t.el); });
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-rrgd]');
    Array.prototype.forEach.call(roots, function (r) {
      if (r.__rrgdReady) return;
      r.__rrgdReady = true;
      initDock(r);
      initReveal(r);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-par-ou-commencer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (!root || root.getAttribute('data-ready')) return;
      root.setAttribute('data-ready', '1');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));

      function sync(panel) {
        if (!panel) return;
        var sc = panel.querySelector('.rr-pc__scroller');
        if (!sc) return;
        var thumb = panel.querySelector('.rr-pc__thumb');
        var prev = panel.querySelector('[data-dir="-1"]');
        var next = panel.querySelector('[data-dir="1"]');
        var ctrl = panel.querySelector('.rr-pc__ctrl');
        var max = sc.scrollWidth - sc.clientWidth;
        if (ctrl) ctrl.hidden = max <= 4;
        if (max <= 4) return;
        var ratio = sc.clientWidth / sc.scrollWidth;
        var progress = Math.min(1, Math.max(0, sc.scrollLeft / max));
        thumb.style.width = ratio * 100 + '%';
        thumb.style.transform = 'translateX(' + progress * (1 / ratio - 1) * 100 + '%)';
        prev.disabled = sc.scrollLeft <= 2;
        next.disabled = sc.scrollLeft >= max - 2;
      }

      function activate(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('aria-labelledby') === tab.id;
          p.hidden = !on;
          if (on) {
            var sc = p.querySelector('.rr-pc__scroller');
            if (sc) sc.scrollLeft = 0;
            sync(p);
          }
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(tab); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0];
          else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); activate(n, true); }
        });
      });

      panels.forEach(function (p) {
        var sc = p.querySelector('.rr-pc__scroller');
        if (!sc) return;
        sc.addEventListener('scroll', function () {
          window.requestAnimationFrame(function () { sync(p); });
        }, { passive: true });
        Array.prototype.forEach.call(p.querySelectorAll('[data-dir]'), function (b) {
          b.addEventListener('click', function () {
            sc.scrollBy({ left: Number(b.getAttribute('data-dir')) * sc.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
          });
        });
      });

      function syncVisible() {
        panels.forEach(function (p) { if (!p.hidden) sync(p); });
      }
      window.addEventListener('resize', syncVisible);
      window.addEventListener('load', syncVisible);
      syncVisible();

      // Défilement automatique : coupé si mouvement réduit ou réglage décoché
      var auto = !reduce && root.getAttribute('data-autoplay') === 'true';
      if (auto) {
        var delay = Math.max(2500, (parseInt(root.getAttribute('data-delay'), 10) || 5) * 1000);
        var playBtn = root.querySelector('.rr-pc__play');
        var paused = false, hovering = false, inView = false, hold = 0;

        function setPlay(on) {
          paused = !on;
          if (!playBtn) return;
          playBtn.setAttribute('aria-pressed', on ? 'false' : 'true');
          playBtn.setAttribute('aria-label', playBtn.getAttribute(on ? 'data-label-pause' : 'data-label-play'));
          var ip = playBtn.querySelector('[data-ic="pause"]');
          var il = playBtn.querySelector('[data-ic="play"]');
          if (ip) ip.hidden = !on;
          if (il) il.hidden = on;
        }
        function holdFor(ms) { hold = Date.now() + ms; }

        function tick() {
          if (!root.isConnected) { window.clearInterval(timer); return; }
          if (paused || hovering || !inView || document.hidden || Date.now() < hold) return;
          var p = null;
          for (var i = 0; i < panels.length; i++) { if (!panels[i].hidden) { p = panels[i]; break; } }
          if (!p) return;
          var sc = p.querySelector('.rr-pc__scroller');
          if (!sc) return;
          if (document.activeElement && sc.contains(document.activeElement)) return;
          var max = sc.scrollWidth - sc.clientWidth;
          if (max <= 4) return;
          var left = sc.scrollLeft;
          var target = 0;
          if (left < max - 4) {
            target = max;
            var kids = sc.querySelectorAll('.rr-pc__track > *');
            var base = sc.getBoundingClientRect().left;
            for (var k = 0; k < kids.length; k++) {
              var x = kids[k].getBoundingClientRect().left - base + left - 24;
              if (x > left + 8) { target = Math.min(x, max); break; }
            }
          }
          sc.scrollTo({ left: target, behavior: 'smooth' });
        }

        var timer = window.setInterval(tick, delay);

        if (playBtn) playBtn.addEventListener('click', function () { holdFor(0); setPlay(paused); });
        panels.forEach(function (p) {
          var sc = p.querySelector('.rr-pc__scroller');
          if (!sc) return;
          // Un toucher, un clic, la molette ou le clavier arrêtent le défilement 3 s
          sc.addEventListener('pointerdown', function () { holdFor(3000); });
          sc.addEventListener('pointerup', function () { holdFor(3000); }, { passive: true });
          sc.addEventListener('click', function () { holdFor(3000); });
          sc.addEventListener('wheel', function () { holdFor(3000); }, { passive: true });
          sc.addEventListener('keydown', function () { holdFor(3000); });
        });
        Array.prototype.forEach.call(root.querySelectorAll('.rr-pc__arrow'), function (b) {
          b.addEventListener('click', function () { holdFor(3000); });
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }, { threshold: 0.3 }).observe(root);
        } else {
          inView = true;
        }
      }
    }

    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-rr-pc]'), init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[role="tab"]') : null;
      if (t) t.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-pdp-matiere"] && !Shopify.designMode) return;
  try {
    (function(){function pl(v){var p=v.play();if(p&&p.catch){p.catch(function(){})}}function init(){var vs=document.querySelectorAll('.rr-pm__vid');if(!vs.length||(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)){return}if(!('IntersectionObserver' in window)){vs.forEach(pl);return}var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){pl(e.target)}else{e.target.pause()}})},{rootMargin:'120px',threshold:0.25});vs.forEach(function(v){io.observe(v)})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();
})();
